import React, { useState, useEffect } from 'react'
import SmartMenuList from './SmartMenuList'
import NavigationStore from '../stores/NavigationStore'

const SmartMenu = () => {
  const [store, setStore] = useState(() => NavigationStore.getInitialState())

  useEffect(() => {
    const unsub = NavigationStore.listen(data => setStore(data))
    return unsub
  }, [])

  return <SmartMenuList items={store.items} />
}

export default SmartMenu
